import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  html {
    box-sizing: border-box;
    font-size: 16px;
  }

  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }

  body,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  ol,
  ul {
    margin: 0;
    padding: 0;
    font-weight: normal;
  }

  ol,
  ul {
    list-style: none;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  body {
    margin: 0;
    color: #191817;
    font-family: 'Noto Sans JP', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .NavLink {
    display: block;
    padding: .5rem;
    color: #eceff4;
    text-decoration: none;

    &:hover {
      background-color: #4c566a;
    }

    &--selected {
      color: #a3be8c;
      font-weight: 700;
      background-color: #4c566a;
    }
  }
`;

export default GlobalStyle;
